import { useContext } from "react";

import { FeedbackToolContext } from "@/features/request/feedback-tool/feedbackTool/components/FeedbackToolProvider.tsx";

export const useFeedbackTool = () => {
  const context = useContext(FeedbackToolContext);

  if (!context) {
    throw new Error("useFeedbackTool need FeedbackToolProvider.");
  }

  return context;
};

export type FeedbackToolContext = ReturnType<typeof useFeedbackTool>;
